enum PlateSize {
  PlateSize96,
  PlateSize96D,
  PlateSize384
}

export default PlateSize;
